<template>
    <base-page empty-header>
        <start-screen-interface
                @login="$router.push({ name: ROUTE_NAME.LOGIN })"
                @register="$router.push({ name: ROUTE_NAME.REGISTER_ADMIN })"
        />
    </base-page>
</template>

<script setup lang="ts">
import { ROUTE_NAME } from "@/router";

import BasePage from "@/components/page/BasePage.vue";
import StartScreenInterface from "@/components/viewInterface/StartScreenInterface.vue";
</script>
